import axios from 'axios';
import { API_URL, WLID, DID, ADID } from '../config/constants';

import { authUserUpdate } from './auth';

export const userInfoFormUpdate = ({ prop, value }) => {

    return {
        type: 'USER_INFO_FORM_UPDATE',
        field: { prop, value }
    }
};

export const userInfoFormError = (message) => {
    return {
        type: 'USER_INFO_FORM_ERROR',
        error: message
    };
}

export const userInfoFormSuccess = (userInfo) => {
    return {
        type: 'USER_INFO_FORM_SUCCESS',
        userInfo
    };
};

export const userInfoLoading = () => {
    return {
        type: 'USER_INFO_FORM_LOADING'
    };
}


export const userInfoUpdate = (params) => {
    
    return (dispatch) => {

        dispatch(userInfoLoading());

        // prepare the params
        if (WLID != 0) {
            params.wlid = WLID;
        }
        if (DID != 0) {
            params.did = DID;
        }
        if (ADID != 0) {
            params.adid = ADID;
        }

        // attempt to update the information
        axios.post(API_URL+'/api/profile', params)
            .then(function(res) {

                if (res.data.status == "success") {
                
                    dispatch(authUserUpdate({ prop: 'first_name', value: params.first_name }));
                    dispatch(authUserUpdate({ prop: 'last_name', value: params.last_name }));
                    dispatch(authUserUpdate({ prop: 'phone', value: params.phone }));
                    dispatch(userInfoFormSuccess(params));
                }
                else {
                    dispatch(userInfoFormError(res.data.message));
                }
            })
            .catch(function(err) {
                console.log(err.response);
                console.log(err);
                dispatch(userInfoFormError("We're sorry, but there was an issue with updating your user info. Please try again shortly."));
            });
    };
}